import Component from '../../../shared/component';
import QuickSubmit from '../../../shared/components/quick-submit';
import RemoteReloadingElement from '../../../shared/components/remote-reloading-element';
import LikeButton from '../like-button';
import CommentButton from '../comment-button';

export default class GroupMessage extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$repliesElement = this.$element.find('.groupMessage-replies');
    this.$replyTextField = this.$element.find(
      '.groupMessage-replyForm-textField'
    );

    this.fetchElements();
    this.bindEvents();
  }

  fetchElements() {
    this.$replyFormElement = this.$element.find('.groupMessage-replyForm');
  }

  bindEvents() {
    this.handleAJAXSuccess = this.handleAJAXSuccess.bind(this);
    this.handleAJAXError = this.handleAJAXError.bind(this);

    this.$replyFormElement.on(
      'ajax:success.GroupMessage',
      this.handleAJAXSuccess
    );
    this.$replyFormElement.on('ajax:error.GroupMessage', this.handleAJAXError);
  }

  unbindEvents() {
    this.$replyFormElement.off(
      'ajax:success.GroupMessage',
      this.handleAJAXSuccess
    );
    this.$replyFormElement.off('ajax:error.GroupMessage', this.handleAJAXError);

    if (this.likeButtons) {
      this.likeButtons.forEach((button) => button.unbindEvents());
    }

    if (this.quickSubmits) {
      this.quickSubmits.forEach((quickSubmit) => quickSubmit.unbindEvents());
    }

    if (this.commentButtons) {
      this.commentButtons.forEach((button) => button.unbindEvents());
    }

    if (this.remoteReloadingElements) {
      this.remoteReloadingElements.forEach((element) => element.unbindEvents());
    }
  }

  reapplyComponentBehavior() {
    this.likeButtons = LikeButton.initialize(this.$element.find('.likeButton'));
    this.quickSubmits = QuickSubmit.initialize(
      this.$element.find('.quickSubmit')
    );
    this.commentButtons = CommentButton.initialize(
      this.$element.find('.commentButton')
    );
    this.remoteReloadingElements = RemoteReloadingElement.initialize(
      this.$element.find('.remoteReloadingElement')
    );
  }

  reloadHTML(html) {
    const newHTML = $('<div />')
      .html(html)
      .find('.groupMessage-replies')
      .html();
    this.unbindEvents();
    this.$repliesElement.html(newHTML);
    this.fetchElements();
    this.bindEvents();
    this.reapplyComponentBehavior();
  }

  handleAJAXSuccess(_, data) {
    this.$replyTextField.val('');
    this.reloadHTML(data);
  }

  handleAJAXError(_, data) {
    if (data.responseJSON.throttled === true) window.Turbolinks.reload();
  }
}
